import React from 'react'
import { useBlocker } from 'react-admin'
import { LeaveDialog } from './LeaveDialog'

/**
 * Trava a saída da tela enquanto há dados preenchidos: o Voltar do navegador, o gesto de voltar do Android, o menu, o
 * link "Descontos" do caminho e "Usar o cadastro completo" perguntam antes. O react-admin cria um roteador com dados
 * (createHashRouter), que é o que o `useBlocker` exige; sem ele (`useCanBlock` falso) a tela usa só o botão Cancelar.
 */
export const LeaveGuard: React.FC<{ dirty: boolean }> = ({ dirty }) => {
  const blocker = useBlocker(dirty)
  const leaving = blocker.state === 'blocked'
  return <LeaveDialog open={leaving} onStay={() => blocker.reset?.()} onLeave={() => blocker.proceed?.()} />
}
